import { jsx as c } from "react/jsx-runtime";
import i from "./index.es2421.js";
import { forwardRef as s } from "react";
import * as a from "./index.es5631.js";
const d = ({ duotoneComponent: t, displayName: o }) => {
  const n = /* @__PURE__ */ new Map([
    ["duotone", t],
    ["regular", a[o]]
  ]), r = s((e, m) => /* @__PURE__ */ c(i, { ref: m, ...e, weights: n, type: "duotone" }));
  return r.displayName = o, r;
};
export {
  d as createDynamicIcon
};
//# sourceMappingURL=index.es674.js.map
